import React from 'react';
import styleable from 'react-styleable';
import '../../../styles/core.scss';
import css from './btn-large-x.scss';

const BtnLargeX = ({ callBack }) => (
  <div
    className={`hwrld ${css.hwrld}`}
    onClick={() => callBack()}
  >
  </div>
);

BtnLargeX.propTypes = {
  callBack: React.PropTypes.func
};

export default styleable(css)(BtnLargeX);
